/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Helmet from "react-helmet"
import Header from "../../template-parts/header/standard"
import Footer from "../../template-parts/footer/"
import EmergencyAlert from "../../template-parts/alerts/emergency"
import SiteWideAlert from "../../template-parts/alerts/site"
import JsShortcodes from "../../utils/js-shortcodes/";
import JsBlocks from "../../utils/js-wpblocks/";
import GoogleTagManagerCANS from "../../template-parts/head/googlecans";
import "../../components/layout.css"

const Layout = ({children}, props) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const closeNavMenus = () => {
    let y = document.getElementsByClassName("sub-menu__wrap");
    document.querySelectorAll(".sub-menu__wrap").forEach.call(y, function(el) {
      el.classList.remove("item-selected");
    });
    let x = document.getElementsByClassName("sub-menu__wrap");
    document.querySelectorAll(".sub-menu__wrap").forEach.call(x, function(el) {
      el.classList.remove("show");
    });
  };

  return (
    <>

    <div id="site-wrapper" onClick={closeNavMenus}>
      <JsShortcodes/>
      <JsBlocks/>
      <Header/>
      <EmergencyAlert/>
      <main id="page-content">
        <SiteWideAlert />
        {children}
      </main>
      <Footer />
    </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout